import { render, staticRenderFns } from "./MergeOrderList.vue?vue&type=template&id=403ac244&"
import script from "./MergeOrderList.vue?vue&type=script&lang=js&"
export * from "./MergeOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports